import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { RelodeTheme, Text } from "../..";

type BarProps = {
    text?: string;
    color: string;
    height?: number;
    percent: number;
    showPercent?: boolean;
};

const useBarStyles = makeStyles<RelodeTheme, BarProps>(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                width: "100%",
                display: "grid",
                gridTemplateColumns: props =>
                    props.showPercent ? `${props.percent}% auto` : "auto 1fr",
                columnGap: 16,
                alignItems: "center",
            },
            text: {
                opacity: 0.8,
                fontSize: 12,
            },
            bar: {
                height: props => `${props.height ?? "18"}px`,
                borderRadius: "0 2px 2px 0",
                marginBottom: -2,
                backgroundColor: props => props.color,
                width: props =>
                    props.showPercent ? "100%" : `${props.percent}%`,
            },
        }),
    { name: "BarGraph" }
);

export const Bar = (props: BarProps) => {
    const classes = useBarStyles(props);
    return props.showPercent ? (
        <div className={classes.root}>
            <div className={classes.bar} />
            <Text className={classes.text}>{props.percent.toFixed(2)}%</Text>
        </div>
    ) : (
        <div className={classes.root}>
            <Text className={classes.text}>
                <b>{props.text}</b>
            </Text>
            <div className={classes.bar} />
        </div>
    );
};
